<div class="ticket-details">
    <h2 *ngIf="ticket.value.id !== 0 || editMode" class="title-header">
        <div class="title-left">
            <span class="material-icons-outlined">confirmation_number</span>
            <a
                class="link"
                [href]="appBaseUrl + 'tickets/' + ticket.value.id"
                (click)="copyOnly($event, appBaseUrl + 'tickets/' + ticket.value.id)"
                [title]="appBaseUrl + 'tickets/' + ticket.value.id"
                >
                <span class="material-icons-outlined">link</span>
            </a>
        </div>
        <div class="header-buttons">
            <ng-container *ngIf="editMode; else viewModeButtons">
                <action-button
                    class="btn-save"
                    (actionEvent)="saveTicket($event)"
                    icon="save"
                    ></action-button>
            </ng-container>
            <button
                *ngIf="isCreating"
                class="btn-cancel"
                (click)="cancelTicket($event)"
                type="button">
                <span class="material-icons-outlined">cancel</span>
            </button>

            <ng-template #viewModeButtons>
                <button class="btn-edit" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">edit</span>
                </button>
                <button class="btn-delete" (click)="deleteTicket()">
                    <span class="material-icons-outlined">delete</span>
                </button>
            </ng-template>
        </div>
    </h2>

    <div class="form-messages">
        <messages
            [form]="ticketForm"
            [messagesObserver]="messages"
            [showNonFieldKeys]="TRUE"
            [showFieldName]="TRUE"
            [showFieldKeys]="FALSE">
        </messages>
    </div>

    <div *ngIf="TicketEmpty()" class="empty-details">
        <span class="material-icons-outlined empty-icon">confirmation_number</span>
    </div>

    <div *ngIf="ticket.value.id !== 0 || editMode" class="ticket-info-container">
        <div *ngIf="ticket.value.id !== 0 && !editMode" class="ticket-info">
            <table>
                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.titleLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                        <span class="span">{{ ticket.value.title }}</span>
                    </td>
                </tr>
                <tr *ngIf="hasValue(ticket.value.description)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.descriptionLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                        <span class="span" [innerHtml]="sanitizeHtml(ticket.value.description)"></span>
                    </td>
                </tr>
                <tr class="registered">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.registeredLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="reg"
                    [topic]="'users'"
                    [icon]="'how_to_reg'"
                    [reduced]="true"
                    [selectedId]="ticket.value.registeredBy"
                    [choiceObserver]="assignedIdObserver"
                    [labelOnDemand]="assignedLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.departmentIdLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="dep"
                    [topic]="'departments'"
                    [icon]="'apartment'"
                    [reduced]="true"
                    [selectedId]="ticket.value.departmentId"
                    [choiceObserver]="departmentIdObserver"
                    [labelOnDemand]="departmentLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr *ngIf="hasValue(assignedLabel)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.assignedLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="usr"
                    [topic]="'users'"
                    [icon]="'person'"
                    [reduced]="true"
                    [selectedId]="ticket.value.assigned"
                    [choiceObserver]="assignedIdObserver"
                    [labelOnDemand]="assignedLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr *ngIf="hasValue(statusLabel)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.statusLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="sts"
                    [topic]="'status'"
                    [icon]="'check_circle'"
                    [reduced]="true"
                    [selectedId]="ticket.value.statusId"
                    [choiceObserver]="statusIdObserver"
                    [labelOnDemand]="statusLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr *ngIf="hasValue(priorityLabel)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.priorityLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="prio"
                    [topic]="'priority'"
                    [icon]="'flag'"
                    [reduced]="true"
                    [selectedId]="ticket.value.priorityId"
                    [choiceObserver]="priorityIdObserver"
                    [labelOnDemand]="priorityLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr *ngIf="hasValue(branchLabel)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.branchIdLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="dc"
                    [topic]="'branches'"
                    [icon]="'domain'"
                    [reduced]="true"
                    [selectedId]="ticket.value.branchId"
                    [choiceObserver]="branchIdObserver"
                    [labelOnDemand]="branchLabelerByService">
                </dependent-choice>
                </td>
                </tr>
            </table>

            <div class="tab-header">
                <div
                    class="tab"
                    *ngFor="let tab of tabs; let i = index"
                    [class.active]="i === selectedIndex"
                    (click)="onTabChange(i)"
                    >
                    <i [class]="tab.icon"></i> {{ tab.label }}
                </div>
            </div>

            <div class="tab-content">
                <div
                    class="tab-pane"
                    *ngFor="let tab of tabs; let i = index"
                    [@tabSlide]="getDirection(i)"
                    [ngClass]="{
                    active: selectedIndex === i
                    }"
                    >
                    <ng-container *ngIf="selectedIndex === i">
                        <ng-container [ngSwitch]="i">


                            <ng-container *ngSwitchCase="0">
                                <comments
                                    #commentsComp
                                    class="comments"
                                    [currentTicket]="ticket"
                                    ></comments>
                            </ng-container>

                            <ng-container *ngSwitchCase="1">
                                <media-list [currentTicket]="ticket"></media-list>
                            </ng-container>

                            <ng-container *ngSwitchCase="2">
                                <involved [currentTicket]="ticket"></involved>
                            </ng-container>
                            <ng-container *ngSwitchCase="3">


                                <ticket-timeline

                                    [items]="items"
                                    [events]="ticket.value.parts.timeline || []"
                                    [referenceLabeler]="statusLabelerByService"
                                    ></ticket-timeline>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <messages
                class="message"
                [form]="ticketForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE"
                ></messages>
        </div>

        <form [formGroup]="ticketForm" *ngIf="editMode" class="ticket-form">
            <div class="form-group">
                <label class="lbt" for="title"
                       >{{ "ticketDetails.titleLabel" | translate }}:</label
                >
                <input type="text" id="title" formControlName="title" />
                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="title"
                    ></messages>
            </div>

            <div class="form-group">
                <label class="descrption" for="description"
                       >{{ "ticketDetails.descriptionLabel" | translate }}:</label
                >
                <div class="editor-container">
                    <p-editor
                        id="description"
                        formControlName="description"
                        [modules]="{ toolbar: false }"
                        ></p-editor>
                </div>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="description"
                    ></messages>
            </div>

            <table>
                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.departmentIdLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <single-choice
                    formControlName="departmentId"
                    [topic]="'departments'"
                    [editMode]="editMode"
                    [ticketId]="ticketId"
                    [icon]="'apartment'"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labeler]="departmentLabeler"
                    [choiceObserver]="departmentIdObserver"
                    [labelOnDemand]="departmentLabelerByService">
                </single-choice>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="departments">
                </messages>
                </td>
                </tr>

                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.assignedLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <single-choice
                    formControlName="assigned"
                    [topic]="'users'"
                    [editMode]="editMode"
                    [ticketId]="ticketId"
                    [icon]="'person'"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labeler]="assignedLabeler"
                    [choiceObserver]="assignedIdObserver"
                    [labelOnDemand]="assignedLabelerByService">
                </single-choice>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="assigned">
                </messages>
                </td>
                </tr>

                <tr *ngIf="!isCreating">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.statusLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <single-choice
                    formControlName="statusId"
                    [topic]="'status'"
                    [editMode]="editMode"
                    [ticketId]="ticketId"
                    [icon]="'check_circle'"
                    (choiceEvent)="relaySingleChoice($event)"
                    [choiceObserver]="statusIdObserver"
                    [labeler]="statusLabeler"
                    [labelOnDemand]="statusLabelerByService">
                </single-choice>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="statusId">
                </messages>
                </td>
                </tr>

                <tr class="priority">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.priorityLabel" | translate }}:
                        </strong>
                    </td>

                    <td>
                        <div class="priority-toggle-wrapper">
                            <label class="toggle-container">
                                <input
                                    type="checkbox"
                                    [checked]="ticketForm.value.priorityId === 1"
                                    (change)="onPriorityToggle($event)"
                                    />
                                <span class="slider"></span>
                            </label>

                            <span class="priority-label">
                                {{
                                ticketForm.value.priorityId === 1
                                    ? ('Hoog' | translate)
                                    : ('Normaal' | translate)
                                }}
                            </span>
                        </div>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="priorityId">
                </messages>
                </td>
                </tr>

                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.branchIdLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <single-choice
                    formControlName="branchId"
                    [topic]="'branches'"
                    [editMode]="editMode"
                    [ticketId]="ticketId"
                    [icon]="'domain'"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labeler]="branchLabeler"
                    [choiceObserver]="branchIdObserver"
                    [labelOnDemand]="branchLabelerByService">
                </single-choice>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="branchId">
                </messages>
                </td>
                </tr>
            </table>
            <messages
                class="message"
                [form]="ticketForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE"
                ></messages>
        </form>
    </div>
</div>
